import meter1 from "../assets/img/html5-logo.svg";
import meter2 from "../assets/img/css3.svg";
import meter3 from "../assets/img/javascript-logo.svg";
import meter4 from "../assets/img/python.svg";
import meter5 from "../assets/img/react-logo.svg";
import meter6 from "../assets/img/arduino.svg";
import meter7 from "../assets/img/typescript.svg";
import meter8 from "../assets/img/tailwind.svg";
import meter9 from "../assets/img/figma.svg";
import meter10 from "../assets/img/expressjs-icon.svg";
import meter11 from "../assets/img/firebase.svg";
import meter12 from "../assets/img/node-js.svg";
import meter13 from "../assets/img/bootstrap.svg";
import meter14 from "../assets/img/amazon_aws-icon.svg";
import meter15 from "../assets/img/axios.svg";
import meter16 from "../assets/img/git-scm-icon.svg";
import meter17 from "../assets/img/hibernate-icon.svg";
import meter18 from "../assets/img/java-icon.svg";
import meter19 from "../assets/img/mongodb-icon.svg";
import meter20 from "../assets/img/mysql-icon.svg";
import meter21 from "../assets/img/nextjs-icon.svg";
import meter22 from "../assets/img/springio-icon.svg";
import meter23 from "../assets/img/swagger.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>A developer's most important tool is the languages he knows how to work with.<br>
                        </br> These are some of my hard-skills:</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            {/* Programming Languages */}
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>HTML5</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h5>CSS3</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h5>JavaScript</h5>
                            </div>

                            <div className="item">
                                <img src={meter18} alt="Image" />
                                <h5>Java</h5>
                            </div>

                            <div className="item">
                                <img src={meter4} alt="Image" />
                                <h5>Python</h5>
                            </div>
                            <div className="item">
                                <img src={meter6} alt="Image" />
                                <h5>Arduino</h5>
                            </div>

                            {/* Libraries & Frameworks */}

                            <div className="item">
                                <img src={meter5} alt="Image" />
                                <h5>React.js</h5>
                            </div>
                            <div className="item">
                                <img src={meter12} alt="Image" />
                                <h5>Node.js</h5>
                            </div>
                            <div className="item">
                                <img src={meter13} alt="Image" />
                                <h5>Bootstrap</h5>
                            </div>
                            <div className="item">
                                <img src={meter7} alt="Image" />
                                <h5>Typescript</h5>
                            </div>
                            <div className="item">
                                <img src={meter10} alt="Image" />
                                <h5>Express.js</h5>
                            </div>
                            <div className="item">
                                <img src={meter21} alt="Image" />
                                <h5>NextJS</h5>
                            </div>

                            <div className="item">
                                <img src={meter8} alt="Image" />
                                <h5>TailwindCSS</h5>
                            </div>

                            <div className="item">
                                <img src={meter22} alt="Image" />
                                <h5>SpringBoot</h5>
                            </div>

                            {/* Databases and Cloud Services */}

                            <div className="item">
                                <img src={meter14} alt="Image" />
                                <h5>AWS</h5>
                            </div>

                            <div className="item">
                                <img src={meter11} alt="Image" />
                                <h5>Firebase</h5>
                            </div>

                            <div className="item">
                                <img src={meter19} alt="Image" />
                                <h5>MongoDB</h5>
                            </div>

                            <div className="item">
                                <img src={meter20} alt="Image" />
                                <h5>MySQL</h5>
                            </div>
                            
                            {/* ORM */}

                            <div className="item">
                                <img src={meter15} alt="Image" />
                                <h5>Axios</h5>
                            </div>

                            <div className="item">
                                <img src={meter17} alt="Image" />
                                <h5>Hibernate</h5>
                            </div>

                            {/* Tools */}
                            <div className="item">
                                <img src={meter9} alt="Image" />
                                <h5>Figma</h5>
                            </div>

                            <div className="item">
                                <img src={meter16} alt="Image" />
                                <h5>Git</h5>
                            </div>

                            <div className="item">
                                <img src={meter23} alt="Image" />
                                <h5>Swaggger</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
